const space = String.fromCharCode(160);

export const formatNum = (n, decimalDigits, decimalDelimiter, groupSeparator) => {
    if (isNaN(n)) {
        return n;
    }

    let c = isNaN(decimalDigits) ? 2 : decimalDigits,
        d = decimalDelimiter || ",",
        t = groupSeparator || space,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = i.length > 3 ? i.length % 3 : 0;

    return (
        s +
        (j ? i.substring(0, j) + t : "") +
        i.substring(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
            ? d +
              Math.abs(n - i)
                  .toFixed(c)
                  .slice(2)
            : "")
    );
};

export const parseNum = (n, decimalDelimiter, groupSeparator) => {
    if (n === null || n === undefined) {
        return n;
    }
    if (typeof n === "number") {
        return n;
    }

    let t = groupSeparator || space,
        d = decimalDelimiter || ",",
        s = n
            .replace(/\s/g, "")
            .replace(new RegExp(`\\${t}`, "g"), "")
            .replace(new RegExp(`\\${d}`, "g"), "."),
        i = parseFloat(s);

    return isNaN(i) ? n : i;
};

export const formatCurrency = (
    value,
    currencyCode,
    currencySettings,
    decimalDigits = 2,
    decimalDelimiter = ",",
    groupSeparator = space
) => {
    let currency = currencySettings?.[currencyCode] || {
        symbol: currencyCode,
        decimalDigits: 2,
        symbolPosition: "left",
    };

    let num = formatNum(value || 0, decimalDigits, decimalDelimiter, groupSeparator);
    if (!currency?.symbol) {
        return num;
    }

    if (currency.symbolPosition === "left") {
        return `${currency.symbol}${space}${num}`;
    }

    return `${num}${space}${currency.symbol}`;
};
